// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  min-height: 100vh;
  background: linear-gradient(to bottom, #e7e3df, #d6d0cc);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.1rem;
}
.main-container .content-container {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-width: 6rem;
  width: 100%;
}
@media (min-width: 768px) {
  .main-container .content-container {
    flex-direction: row;
    height: 50vh;
  }
}
.main-container .content-container .content-box {
  flex: 1 1;
  background: #f3eee8;
  border-radius: 0.05rem;
  box-shadow: 0 0.025rem 0.05rem rgba(0, 0, 0, 0.1);
  padding: 0.1rem;
  overflow-y: auto;
}
.main-container .content-container .content-box .window-buttons {
  display: flex;
  gap: 0.05rem;
  margin-bottom: 0.1rem;
}
.main-container .content-container .content-box .window-buttons .button {
  width: 0.075rem;
  height: 0.075rem;
  border-radius: 50%;
}
.main-container .content-container .content-box .window-buttons .button.l {
  background: #b5ada6;
}
.main-container .content-container .content-box .window-buttons .button.c {
  background: #c8c1ba;
}
.main-container .content-container .content-box .window-buttons .button.r {
  background: #a39e99;
}
.main-container .content-container .content-box .content {
  font-size: 0.0875rem;
  color: #6b6560;
}
.main-container .content-container .content-box .content pre {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 0.1375rem;
}
.main-container .content-container .content-box .content .code-import {
  color: #9c8e83;
}
.main-container .content-container .content-box .content .code-comment {
  color: #b5ada6;
  font-style: italic;
}
.main-container .content-container .content-box .content .code-function {
  color: #847971;
}
.main-container .content-container .content-box .content .code-default {
  color: #6b6560;
}
.main-container .content-container .content-box .content div {
  display: block;
}
.main-container .content-container .arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-container .content-container .arrow-container .arrow {
  font-size: 0.15rem;
  color: #9c8e83;
  animation: arrowMove 1.5s ease-in-out infinite;
}
.main-container .result-section {
  margin-top: 0.375rem;
  text-align: center;
  animation: des-ani 600ms linear forwards;
}
@keyframes des-ani {
  0% {
    opacity: 0;
    margin-top: 0;
  }
  100% {
    opacity: 1;
    margin-top: 40;
  }
}
.main-container .result-section .result-title {
  color: #9c8e83;
  font-size: 0.15rem;
  font-weight: bold;
  margin-bottom: 0.15rem;
}
.main-container .result-section .enter-button {
  background: #9c8e83;
  color: #f3eee8;
  font-weight: bold;
  padding: 0.075rem 0.2rem;
  border-radius: 62.49375rem;
  transition: background 0.3s;
  border: none;
  cursor: pointer;
}
.main-container .result-section .enter-button:hover {
  background: #847971;
  animation: button-ani 200ms linear forwards;
}
@keyframes button-ani {
  100% {
    transform: scale(1.02);
    box-shadow: 0 0.025rem 0.05rem rgba(0, 0, 0, 0.1);
  }
}
.main-container .cursor {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
@keyframes arrowMove {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(0.0625rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/enterApp/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,wDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAEJ;AADI;EANF;IAOI,mBAAA;IACA,YAAA;EAIJ;AACF;AAHI;EACE,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA;AAKN;AAJM;EACE,aAAA;EACA,YAAA;EACA,qBAAA;AAMR;AALQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAOV;AANU;EACE,mBAAA;AAQZ;AANU;EACE,mBAAA;AAQZ;AANU;EACE,mBAAA;AAQZ;AAJM;EACE,oBAAA;EACA,cAAA;AAMR;AALQ;EACE,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAOV;AALQ;EACE,cAAA;AAOV;AALQ;EACE,cAAA;EACA,kBAAA;AAOV;AALQ;EACE,cAAA;AAOV;AALQ;EACE,cAAA;AAOV;AALQ;EACE,cAAA;AAOV;AAHI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAKN;AAJM;EACE,kBAAA;EACA,cAAA;EACA,8CAAA;AAMR;AAFE;EACE,oBAAA;EACA,kBAAA;EACA,wCAAA;AAIJ;AAHI;EACE;IACE,UAAA;IACA,aAAA;EAKN;EAHI;IACE,UAAA;IACA,cAAA;EAKN;AACF;AAHI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAKN;AAHI;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;AAKN;AAJM;EACE,mBAAA;EACA,2CAAA;AAMR;AAJM;EACE;IACE,sBAAA;IACA,iDAAA;EAMR;AACF;AAFE;EACE,4BAAA;AAIJ;;AADA;EACE;IAEE,UAAA;EAGF;EADA;IACE,UAAA;EAGF;AACF;AAAA;EACE;IAEE,wBAAA;EACF;EACA;IACE,gCAAA;EACF;AACF","sourcesContent":[".main-container {\n  min-height: 100vh;\n  background: linear-gradient(to bottom, #e7e3df, #d6d0cc);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  .content-container {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    max-width: 960px;\n    width: 100%;\n    @media (min-width: 768px) {\n      flex-direction: row;\n      height: 50vh;\n    }\n    .content-box {\n      flex: 1;\n      background: #f3eee8;\n      border-radius: 8px;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n      padding: 16px;\n      overflow-y: auto;\n      .window-buttons {\n        display: flex;\n        gap: 8px;\n        margin-bottom: 16px;\n        .button {\n          width: 12px;\n          height: 12px;\n          border-radius: 50%;\n          &.l {\n            background: #b5ada6;\n          }\n          &.c {\n            background: #c8c1ba;\n          }\n          &.r {\n            background: #a39e99;\n          }\n        }\n      }\n      .content {\n        font-size: 14px;\n        color: #6b6560;\n        pre {\n          white-space: pre-wrap;\n          overflow-wrap: break-word;\n          word-break: break-word;\n          line-height: 22px;\n        }\n        .code-import {\n          color: #9c8e83;\n        }\n        .code-comment {\n          color: #b5ada6;\n          font-style: italic;\n        }\n        .code-function {\n          color: #847971;\n        }\n        .code-default {\n          color: #6b6560;\n        }\n        div {\n          display: block;\n        }\n      }\n    }\n    .arrow-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .arrow {\n        font-size: 24px;\n        color: #9c8e83;\n        animation: arrowMove 1.5s ease-in-out infinite;\n      }\n    }\n  }\n  .result-section {\n    margin-top: 60px;\n    text-align: center;\n    animation: des-ani 600ms linear forwards;\n    @keyframes des-ani {\n      0% {\n        opacity: 0;\n        margin-top: 0;\n      }\n      100% {\n        opacity: 1;\n        margin-top: 40;\n      }\n    }\n    .result-title {\n      color: #9c8e83;\n      font-size: 24px;\n      font-weight: bold;\n      margin-bottom: 24px;\n    }\n    .enter-button {\n      background: #9c8e83;\n      color: #f3eee8;\n      font-weight: bold;\n      padding: 12px 32px;\n      border-radius: 9999px;\n      transition: background 0.3s;\n      border: none;\n      cursor: pointer;\n      &:hover {\n        background: #847971;\n        animation: button-ani 200ms linear forwards;\n      }\n      @keyframes button-ani {\n        100% {\n          transform: scale(1.02);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n  }\n  .cursor {\n    animation: pulse 1s infinite;\n  }\n}\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n@keyframes arrowMove {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(10px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
